import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove external branding badges
(function removeBranding() {
  const remove = () => {
    const el = document.getElementById('emergent-badge');
    if (el) { el.style.setProperty('display', 'none', 'important'); el.remove(); }
    document.querySelectorAll('a[href*="emergent"]').forEach(a => {
      if (a.textContent.includes('Made with')) a.remove();
    });
  };
  remove();
  const obs = new MutationObserver(remove);
  obs.observe(document.body, { childList: true, subtree: true });
  setInterval(remove, 500);
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
